import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Section, SectionHeading } from './ui/Section';
import { FiExternalLink } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { motion } from 'framer-motion';

const Projects = () => {
  const { t } = useLanguage();

  return (
    <Section id="projects" bg="bg-brand-dark">
      <div className="max-w-4xl mx-auto text-center mb-16">
        <SectionHeading>{t.projects.heading}</SectionHeading>
        <p className="text-xl text-brand-textMuted mt-6 leading-relaxed">
          {t.projects.subheading}
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {t.projects.items.map((project, index) => (
          <motion.a
            key={index}
            href={project.link}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
            className="group bg-brand-card border border-brand-border rounded-2xl p-6 hover:border-brand-accent/40 transition-all duration-300 flex flex-col h-full relative overflow-hidden"
          >
            {/* Background Accent */}
            <div className="absolute top-0 right-0 w-24 h-24 bg-brand-accent/5 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2 group-hover:bg-brand-accent/10 transition-colors"></div>

            <div className="flex justify-between items-start mb-4">
              <div className="flex flex-wrap gap-1.5">
                {project.tags.map((tag, i) => (
                  <span key={i} className="px-2 py-0.5 bg-brand-dark border border-brand-border rounded text-[9px] font-bold uppercase tracking-wider text-brand-textMuted group-hover:text-brand-accent transition-colors">
                    {tag}
                  </span>
                ))}
              </div>
              <SafeIcon icon={FiExternalLink} className="w-4 h-4 text-brand-textMuted group-hover:text-brand-accent transition-colors flex-shrink-0" />
            </div>

            <h3 className="text-lg font-bold text-brand-textHeading mb-3 group-hover:text-brand-accent transition-colors">
              {project.title}
            </h3>
            
            <p className="text-brand-textMuted leading-relaxed text-xs flex-grow">
              {project.desc}
            </p>

            <div className="mt-6 pt-4 border-t border-brand-border/50 flex items-center text-xs font-semibold text-brand-text group-hover:text-white transition-colors">
              {t.projects.visitLink}
              <span className="ml-2 transform group-hover:translate-x-1 transition-transform">→</span>
            </div>
          </motion.a>
        ))}
      </div>
    </Section>
  );
};

export default Projects;